import Loading from 'vue-loading-overlay';
import { VinDecoderService } from "../../../api/VinDecoderService";


export default {
    name: "AcesUpload",
    _service: null,
    data() {
        return {
            isImporting: false,
            isLoading: true,
            isLoadingFailed: false,
            isSelectingFile: false,
            isShowingStatus: false,
            isUploading: false,
            isUploadingFailed: false,            
            file: undefined,
            fileName: "",
            uploadFailedReason: "Unknown",
            importStatus: undefined,
            service: undefined
        }
    },
    validations: {
    },
    components: {
        Loading
    },
    created() {
        this.service = new VinDecoderService(null);
        this.refreshImportStatus();
    },
    mounted() {        
        
    },
    methods: {
        /**
         * Starts a recurring interval to check on the status of the executing
         * import job.  Every 15 seconds this sends out a request for updates
         * and displays the results in real time.        
         */
        watchImportStatus() {
            let fails = 0;
            let intervalId = setInterval(() => {
                this.service.getAcesStatus("current")
                    .then(importStatus => {
                        this.importStatus = importStatus;
                        this.determineStateByStatus(importStatus, false);
                        if (importStatus.timeEnded) {
                            clearInterval(intervalId);
                        }
                    })
                    .catch(ex => {
                        console.log("Failed to update ACES Import status...");
                        console.log(ex);
                        fails++;
                        if (fails > 3) {
                            clearInterval(intervalId);
                        }
                    });
            }, 15000);            
        },
        refreshImportStatus() {
            this.service.getAcesStatus("current")
                .then(importStatus => {
                    this.importStatus = importStatus;
                    this.determineStateByStatus(importStatus);
                })
                .catch(ex => {
                    this.isLoading = false;
                    this.isLoadingFailed = true;
                });
        },
        clearStateFlags() {
            this.isImporting = false;
            this.isImportingFailed = false;
            this.isImportingComplete = false;
            this.isLoading = false;
            this.isLoadingFailed = false;
            this.isSelectingFile = false;
            this.isUploading = false;
            this.isUploadingFailed = false;
        },
        determineStateByStatus(importStatus, enableWatch) {
            if (enableWatch === undefined) {
                enableWatch = true;
            }
            this.clearStateFlags();
            if (!importStatus) {
                // No import status so assume file selection is allowed
                this.isSelectingFile = true;
            } else {
                this.isShowingStatus = true;
                switch (importStatus.status) {
                    case "Queued":
                    case "Executing":
                        this.isImporting = true;
                        if (enableWatch) {
                            this.watchImportStatus();
                        }
                        break;
                    case "Error":                        
                    case "Succeeded":
                        this.isSelectingFile = true;                                           
                        break;
                }
            }
        },
        onSubmit() {
            const service = new VinDecoderService(null);
            service.uploadAcesDb(this.file)
                .then(importStatus => {
                    this.importStatus = importStatus;
                    this.determineStateByStatus(this.importStatus);                    
                })
                .catch(ex => {
                    debugger;
                    this.clearStateFlags();
                    this.isUploadingFailed = true;
                    if (ex && ex.message) {
                        this.uploadFailedReason = ex.message;
                    } else {
                        this.uploadFailedReason = "Unknown";
                    }
                });
        },
        triggerFileInput(event) {
            this.$refs.fileInput.click();
            event.preventDefault();
        },
        handleFileChange(event) {
            const selectedFile = event.target.files[0];
            if (selectedFile) {
                this.file = selectedFile;
                this.fileName = selectedFile.name;
            }
        },
        handleUpload() {
            this.$refs.upload.submit(); // Manually trigger the upload process
        }
    },
    onCancel() {
        this.$router.back();
    },
    onSubmit() {
    }
}